// This file is auto-generated by tools/generate-spell-assets.js. Do not edit manually.

import { GridSheetDescriptor } from '../../../types/sprite.types';

export const GRID_SHEETS: GridSheetDescriptor[] = [
  {
    id: 'bullet-1a',
    image: '/sprites/bullets/bullet-1a.png',
    cell: 24,
    cols: 24,
    rows: 15,
  },
  {
    id: 'bullet-1b',
    image: '/sprites/bullets/bullet-1b.png',
    cell: 24,
    cols: 24,
    rows: 15,
  },
  {
    id: 'bullet-1c',
    image: '/sprites/bullets/bullet-1c.png',
    cell: 24,
    cols: 24,
    rows: 15,
  },
  {
    id: 'bullet-2a',
    image: '/sprites/bullets/bullet-2a.png',
    cell: 24,
    cols: 24,
    rows: 15,
  },
  {
    id: 'bullet-2b',
    image: '/sprites/bullets/bullet-2b.png',
    cell: 24,
    cols: 24,
    rows: 15,
  },
  {
    id: 'bullet-2c',
    image: '/sprites/bullets/bullet-2c.png',
    cell: 24,
    cols: 24,
    rows: 15,
  },
  {
    id: 'bullet-3a',
    image: '/sprites/bullets/bullet-3a.png',
    cell: 24,
    cols: 24,
    rows: 15,
  },
  {
    id: 'bullet-3b',
    image: '/sprites/bullets/bullet-3b.png',
    cell: 24,
    cols: 24,
    rows: 15,
  },
  {
    id: 'bullet-3c',
    image: '/sprites/bullets/bullet-3c.png',
    cell: 24,
    cols: 24,
    rows: 15,
  },
  {
    id: 'bullet-4a',
    image: '/sprites/bullets/bullet-4a.png',
    cell: 24,
    cols: 24,
    rows: 15,
  },
  {
    id: 'bullet-4b',
    image: '/sprites/bullets/bullet-4b.png',
    cell: 24,
    cols: 24,
    rows: 15,
  },
  {
    id: 'bullet-4c',
    image: '/sprites/bullets/bullet-4c.png',
    cell: 24,
    cols: 24,
    rows: 15,
  },
  {
    id: 'bullet-5a',
    image: '/sprites/bullets/bullet-5a.png',
    cell: 24,
    cols: 24,
    rows: 15,
  },
  {
    id: 'bullet-5b',
    image: '/sprites/bullets/bullet-5b.png',
    cell: 24,
    cols: 24,
    rows: 15,
  },
  {
    id: 'bullet-5c',
    image: '/sprites/bullets/bullet-5c.png',
    cell: 24,
    cols: 24,
    rows: 15,
  },
  {
    id: 'bullet-6a',
    image: '/sprites/bullets/bullet-6a.png',
    cell: 24,
    cols: 24,
    rows: 15,
  },
  {
    id: 'bullet-6b',
    image: '/sprites/bullets/bullet-6b.png',
    cell: 24,
    cols: 24,
    rows: 15,
  },
  {
    id: 'bullet-6c',
    image: '/sprites/bullets/bullet-6c.png',
    cell: 24,
    cols: 24,
    rows: 15,
  },
  {
    id: 'bullet-7a',
    image: '/sprites/bullets/bullet-7a.png',
    cell: 24,
    cols: 24,
    rows: 15,
  },
  {
    id: 'bullet-7b',
    image: '/sprites/bullets/bullet-7b.png',
    cell: 24,
    cols: 24,
    rows: 15,
  },
  {
    id: 'bullet-7c',
    image: '/sprites/bullets/bullet-7c.png',
    cell: 24,
    cols: 24,
    rows: 15,
  },
  {
    id: 'bullet-8a',
    image: '/sprites/bullets/bullet-8a.png',
    cell: 24,
    cols: 24,
    rows: 15,
  },
  {
    id: 'bullet-8b',
    image: '/sprites/bullets/bullet-8b.png',
    cell: 24,
    cols: 24,
    rows: 15,
  },
  {
    id: 'bullet-8c',
    image: '/sprites/bullets/bullet-8c.png',
    cell: 24,
    cols: 24,
    rows: 15,
  },
  {
    id: 'bullet-9a',
    image: '/sprites/bullets/bullet-9a.png',
    cell: 24,
    cols: 24,
    rows: 15,
  },
  {
    id: 'bullet-9b',
    image: '/sprites/bullets/bullet-9b.png',
    cell: 24,
    cols: 24,
    rows: 15,
  },
  {
    id: 'bullet-9c',
    image: '/sprites/bullets/bullet-9c.png',
    cell: 24,
    cols: 24,
    rows: 15,
  },
  {
    id: 'bullet-10a',
    image: '/sprites/bullets/bullet-10a.png',
    cell: 24,
    cols: 24,
    rows: 15,
  },
  {
    id: 'bullet-10b',
    image: '/sprites/bullets/bullet-10b.png',
    cell: 24,
    cols: 24,
    rows: 15,
  },
  {
    id: 'bullet-10c',
    image: '/sprites/bullets/bullet-10c.png',
    cell: 24,
    cols: 24,
    rows: 15,
  },
  {
    id: 'spell-03',
    image: '/sprites/spells/spell-03.png',
    cell: 64,
    cols: 13,
    rows: 9,
  },
  {
    id: 'spell-04',
    image: '/sprites/spells/spell-04.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-05',
    image: '/sprites/spells/spell-05.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-06',
    image: '/sprites/spells/spell-06.png',
    cell: 64,
    cols: 15,
    rows: 9,
  },
  {
    id: 'spell-13',
    image: '/sprites/spells/spell-13.png',
    cell: 64,
    cols: 13,
    rows: 9,
  },
  {
    id: 'spell-14',
    image: '/sprites/spells/spell-14.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-15',
    image: '/sprites/spells/spell-15.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-16',
    image: '/sprites/spells/spell-16.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-23',
    image: '/sprites/spells/spell-23.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-24',
    image: '/sprites/spells/spell-24.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-25',
    image: '/sprites/spells/spell-25.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-26',
    image: '/sprites/spells/spell-26.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-62',
    image: '/sprites/spells/spell-62.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-63',
    image: '/sprites/spells/spell-63.png',
    cell: 64,
    cols: 7,
    rows: 9,
  },
  {
    id: 'spell-64',
    image: '/sprites/spells/spell-64.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-65',
    image: '/sprites/spells/spell-65.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-69',
    image: '/sprites/spells/spell-69.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-70',
    image: '/sprites/spells/spell-70.png',
    cell: 64,
    cols: 9,
    rows: 9,
  },
  {
    id: 'spell-71',
    image: '/sprites/spells/spell-71.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-72',
    image: '/sprites/spells/spell-72.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-76',
    image: '/sprites/spells/spell-76.png',
    cell: 64,
    cols: 11,
    rows: 9,
  },
  {
    id: 'spell-77',
    image: '/sprites/spells/spell-77.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-78',
    image: '/sprites/spells/spell-78.png',
    cell: 64,
    cols: 11,
    rows: 9,
  },
  {
    id: 'spell-79',
    image: '/sprites/spells/spell-79.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-113',
    image: '/sprites/spells/spell-113.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-114',
    image: '/sprites/spells/spell-114.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-115',
    image: '/sprites/spells/spell-115.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-116',
    image: '/sprites/spells/spell-116.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-123',
    image: '/sprites/spells/spell-123.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-124',
    image: '/sprites/spells/spell-124.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-125',
    image: '/sprites/spells/spell-125.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-126',
    image: '/sprites/spells/spell-126.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-133',
    image: '/sprites/spells/spell-133.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-134',
    image: '/sprites/spells/spell-134.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-135',
    image: '/sprites/spells/spell-135.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-136',
    image: '/sprites/spells/spell-136.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-174',
    image: '/sprites/spells/spell-174.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-175',
    image: '/sprites/spells/spell-175.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-176',
    image: '/sprites/spells/spell-176.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-177',
    image: '/sprites/spells/spell-177.png',
    cell: 64,
    cols: 11,
    rows: 9,
  },
  {
    id: 'spell-184',
    image: '/sprites/spells/spell-184.png',
    cell: 64,
    cols: 11,
    rows: 9,
  },
  {
    id: 'spell-185',
    image: '/sprites/spells/spell-185.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-186',
    image: '/sprites/spells/spell-186.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-187',
    image: '/sprites/spells/spell-187.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-194',
    image: '/sprites/spells/spell-194.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-195',
    image: '/sprites/spells/spell-195.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-196',
    image: '/sprites/spells/spell-196.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-197',
    image: '/sprites/spells/spell-197.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-220',
    image: '/sprites/spells/spell-220.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-221',
    image: '/sprites/spells/spell-221.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-222',
    image: '/sprites/spells/spell-222.png',
    cell: 64,
    cols: 9,
    rows: 9,
  },
  {
    id: 'spell-223',
    image: '/sprites/spells/spell-223.png',
    cell: 64,
    cols: 5,
    rows: 9,
  },
  {
    id: 'spell-230',
    image: '/sprites/spells/spell-230.png',
    cell: 64,
    cols: 5,
    rows: 9,
  },
  {
    id: 'spell-231',
    image: '/sprites/spells/spell-231.png',
    cell: 64,
    cols: 9,
    rows: 9,
  },
  {
    id: 'spell-232',
    image: '/sprites/spells/spell-232.png',
    cell: 64,
    cols: 9,
    rows: 9,
  },
  {
    id: 'spell-233',
    image: '/sprites/spells/spell-233.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-240',
    image: '/sprites/spells/spell-240.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-241',
    image: '/sprites/spells/spell-241.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-242',
    image: '/sprites/spells/spell-242.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-243',
    image: '/sprites/spells/spell-243.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-273',
    image: '/sprites/spells/spell-273.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-274',
    image: '/sprites/spells/spell-274.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-275',
    image: '/sprites/spells/spell-275.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-276',
    image: '/sprites/spells/spell-276.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-283',
    image: '/sprites/spells/spell-283.png',
    cell: 64,
    cols: 9,
    rows: 9,
  },
  {
    id: 'spell-284',
    image: '/sprites/spells/spell-284.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-285',
    image: '/sprites/spells/spell-285.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-286',
    image: '/sprites/spells/spell-286.png',
    cell: 64,
    cols: 9,
    rows: 9,
  },
  {
    id: 'spell-293',
    image: '/sprites/spells/spell-293.png',
    cell: 64,
    cols: 9,
    rows: 9,
  },
  {
    id: 'spell-294',
    image: '/sprites/spells/spell-294.png',
    cell: 64,
    cols: 9,
    rows: 9,
  },
  {
    id: 'spell-295',
    image: '/sprites/spells/spell-295.png',
    cell: 64,
    cols: 9,
    rows: 9,
  },
  {
    id: 'spell-296',
    image: '/sprites/spells/spell-296.png',
    cell: 64,
    cols: 9,
    rows: 9,
  },
  {
    id: 'spell-313',
    image: '/sprites/spells/spell-313.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-314',
    image: '/sprites/spells/spell-314.png',
    cell: 64,
    cols: 9,
    rows: 9,
  },
  {
    id: 'spell-315',
    image: '/sprites/spells/spell-315.png',
    cell: 64,
    cols: 7,
    rows: 9,
  },
  {
    id: 'spell-316',
    image: '/sprites/spells/spell-316.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-323',
    image: '/sprites/spells/spell-323.png',
    cell: 64,
    cols: 6,
    rows: 9,
  },
  {
    id: 'spell-324',
    image: '/sprites/spells/spell-324.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-325',
    image: '/sprites/spells/spell-325.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-326',
    image: '/sprites/spells/spell-326.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-333',
    image: '/sprites/spells/spell-333.png',
    cell: 64,
    cols: 9,
    rows: 9,
  },
  {
    id: 'spell-334',
    image: '/sprites/spells/spell-334.png',
    cell: 64,
    cols: 9,
    rows: 9,
  },
  {
    id: 'spell-335',
    image: '/sprites/spells/spell-335.png',
    cell: 64,
    cols: 9,
    rows: 9,
  },
  {
    id: 'spell-336',
    image: '/sprites/spells/spell-336.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-375',
    image: '/sprites/spells/spell-375.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-376',
    image: '/sprites/spells/spell-376.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-377',
    image: '/sprites/spells/spell-377.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-378',
    image: '/sprites/spells/spell-378.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-385',
    image: '/sprites/spells/spell-385.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-386',
    image: '/sprites/spells/spell-386.png',
    cell: 64,
    cols: 9,
    rows: 9,
  },
  {
    id: 'spell-387',
    image: '/sprites/spells/spell-387.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-388',
    image: '/sprites/spells/spell-388.png',
    cell: 64,
    cols: 9,
    rows: 9,
  },
  {
    id: 'spell-395',
    image: '/sprites/spells/spell-395.png',
    cell: 64,
    cols: 9,
    rows: 9,
  },
  {
    id: 'spell-396',
    image: '/sprites/spells/spell-396.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-397',
    image: '/sprites/spells/spell-397.png',
    cell: 64,
    cols: 9,
    rows: 9,
  },
  {
    id: 'spell-398',
    image: '/sprites/spells/spell-398.png',
    cell: 64,
    cols: 9,
    rows: 9,
  },
  {
    id: 'spell-426',
    image: '/sprites/spells/spell-426.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-427',
    image: '/sprites/spells/spell-427.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-428',
    image: '/sprites/spells/spell-428.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-429',
    image: '/sprites/spells/spell-429.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-436',
    image: '/sprites/spells/spell-436.png',
    cell: 64,
    cols: 9,
    rows: 9,
  },
  {
    id: 'spell-437',
    image: '/sprites/spells/spell-437.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-438',
    image: '/sprites/spells/spell-438.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-439',
    image: '/sprites/spells/spell-439.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-446',
    image: '/sprites/spells/spell-446.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-447',
    image: '/sprites/spells/spell-447.png',
    cell: 64,
    cols: 9,
    rows: 9,
  },
  {
    id: 'spell-448',
    image: '/sprites/spells/spell-448.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-449',
    image: '/sprites/spells/spell-449.png',
    cell: 64,
    cols: 9,
    rows: 9,
  },
  {
    id: 'spell-464',
    image: '/sprites/spells/spell-464.png',
    cell: 64,
    cols: 11,
    rows: 9,
  },
  {
    id: 'spell-465',
    image: '/sprites/spells/spell-465.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-466',
    image: '/sprites/spells/spell-466.png',
    cell: 64,
    cols: 11,
    rows: 9,
  },
  {
    id: 'spell-467',
    image: '/sprites/spells/spell-467.png',
    cell: 64,
    cols: 11,
    rows: 9,
  },
  {
    id: 'spell-474',
    image: '/sprites/spells/spell-474.png',
    cell: 64,
    cols: 11,
    rows: 9,
  },
  {
    id: 'spell-475',
    image: '/sprites/spells/spell-475.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-476',
    image: '/sprites/spells/spell-476.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-477',
    image: '/sprites/spells/spell-477.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-484',
    image: '/sprites/spells/spell-484.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-485',
    image: '/sprites/spells/spell-485.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-486',
    image: '/sprites/spells/spell-486.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-487',
    image: '/sprites/spells/spell-487.png',
    cell: 64,
    cols: 11,
    rows: 9,
  },
  {
    id: 'spell-506',
    image: '/sprites/spells/spell-506.png',
    cell: 64,
    cols: 11,
    rows: 9,
  },
  {
    id: 'spell-507',
    image: '/sprites/spells/spell-507.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-508',
    image: '/sprites/spells/spell-508.png',
    cell: 64,
    cols: 13,
    rows: 9,
  },
  {
    id: 'spell-509',
    image: '/sprites/spells/spell-509.png',
    cell: 64,
    cols: 13,
    rows: 9,
  },
  {
    id: 'spell-516',
    image: '/sprites/spells/spell-516.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-517',
    image: '/sprites/spells/spell-517.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-518',
    image: '/sprites/spells/spell-518.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-519',
    image: '/sprites/spells/spell-519.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-526',
    image: '/sprites/spells/spell-526.png',
    cell: 64,
    cols: 9,
    rows: 9,
  },
  {
    id: 'spell-527',
    image: '/sprites/spells/spell-527.png',
    cell: 64,
    cols: 13,
    rows: 9,
  },
  {
    id: 'spell-528',
    image: '/sprites/spells/spell-528.png',
    cell: 64,
    cols: 13,
    rows: 9,
  },
  {
    id: 'spell-529',
    image: '/sprites/spells/spell-529.png',
    cell: 64,
    cols: 13,
    rows: 9,
  },
  {
    id: 'spell-566',
    image: '/sprites/spells/spell-566.png',
    cell: 64,
    cols: 13,
    rows: 9,
  },
  {
    id: 'spell-567',
    image: '/sprites/spells/spell-567.png',
    cell: 64,
    cols: 13,
    rows: 9,
  },
  {
    id: 'spell-568',
    image: '/sprites/spells/spell-568.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-569',
    image: '/sprites/spells/spell-569.png',
    cell: 64,
    cols: 13,
    rows: 9,
  },
  {
    id: 'spell-576',
    image: '/sprites/spells/spell-576.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-577',
    image: '/sprites/spells/spell-577.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-578',
    image: '/sprites/spells/spell-578.png',
    cell: 64,
    cols: 11,
    rows: 9,
  },
  {
    id: 'spell-579',
    image: '/sprites/spells/spell-579.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-586',
    image: '/sprites/spells/spell-586.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-587',
    image: '/sprites/spells/spell-587.png',
    cell: 64,
    cols: 13,
    rows: 9,
  },
  {
    id: 'spell-588',
    image: '/sprites/spells/spell-588.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-589',
    image: '/sprites/spells/spell-589.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-612',
    image: '/sprites/spells/spell-612.png',
    cell: 64,
    cols: 15,
    rows: 9,
  },
  {
    id: 'spell-613',
    image: '/sprites/spells/spell-613.png',
    cell: 64,
    cols: 15,
    rows: 9,
  },
  {
    id: 'spell-614',
    image: '/sprites/spells/spell-614.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-615',
    image: '/sprites/spells/spell-615.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-622',
    image: '/sprites/spells/spell-622.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-623',
    image: '/sprites/spells/spell-623.png',
    cell: 64,
    cols: 13,
    rows: 9,
  },
  {
    id: 'spell-624',
    image: '/sprites/spells/spell-624.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-625',
    image: '/sprites/spells/spell-625.png',
    cell: 64,
    cols: 15,
    rows: 9,
  },
  {
    id: 'spell-632',
    image: '/sprites/spells/spell-632.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-633',
    image: '/sprites/spells/spell-633.png',
    cell: 64,
    cols: 15,
    rows: 9,
  },
  {
    id: 'spell-634',
    image: '/sprites/spells/spell-634.png',
    cell: 64,
    cols: 15,
    rows: 9,
  },
  {
    id: 'spell-635',
    image: '/sprites/spells/spell-635.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-652',
    image: '/sprites/spells/spell-652.png',
    cell: 64,
    cols: 16,
    rows: 9,
  },
  {
    id: 'spell-653',
    image: '/sprites/spells/spell-653.png',
    cell: 64,
    cols: 17,
    rows: 9,
  },
  {
    id: 'spell-654',
    image: '/sprites/spells/spell-654.png',
    cell: 64,
    cols: 17,
    rows: 9,
  },
  {
    id: 'spell-655',
    image: '/sprites/spells/spell-655.png',
    cell: 64,
    cols: 15,
    rows: 9,
  },
  {
    id: 'spell-662',
    image: '/sprites/spells/spell-662.png',
    cell: 64,
    cols: 15,
    rows: 9,
  },
  {
    id: 'spell-663',
    image: '/sprites/spells/spell-663.png',
    cell: 64,
    cols: 16,
    rows: 9,
  },
  {
    id: 'spell-664',
    image: '/sprites/spells/spell-664.png',
    cell: 64,
    cols: 16,
    rows: 9,
  },
  {
    id: 'spell-665',
    image: '/sprites/spells/spell-665.png',
    cell: 64,
    cols: 16,
    rows: 9,
  },
  {
    id: 'spell-672',
    image: '/sprites/spells/spell-672.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-673',
    image: '/sprites/spells/spell-673.png',
    cell: 64,
    cols: 18,
    rows: 9,
  },
  {
    id: 'spell-674',
    image: '/sprites/spells/spell-674.png',
    cell: 64,
    cols: 18,
    rows: 9,
  },
  {
    id: 'spell-675',
    image: '/sprites/spells/spell-675.png',
    cell: 64,
    cols: 19,
    rows: 9,
  },
  {
    id: 'spell-700',
    image: '/sprites/spells/spell-700.png',
    cell: 64,
    cols: 22,
    rows: 9,
  },
  {
    id: 'spell-701',
    image: '/sprites/spells/spell-701.png',
    cell: 64,
    cols: 19,
    rows: 9,
  },
  {
    id: 'spell-702',
    image: '/sprites/spells/spell-702.png',
    cell: 64,
    cols: 17,
    rows: 9,
  },
  {
    id: 'spell-703',
    image: '/sprites/spells/spell-703.png',
    cell: 64,
    cols: 22,
    rows: 9,
  },
  {
    id: 'spell-710',
    image: '/sprites/spells/spell-710.png',
    cell: 64,
    cols: 18,
    rows: 9,
  },
  {
    id: 'spell-711',
    image: '/sprites/spells/spell-711.png',
    cell: 64,
    cols: 20,
    rows: 9,
  },
  {
    id: 'spell-712',
    image: '/sprites/spells/spell-712.png',
    cell: 64,
    cols: 21,
    rows: 9,
  },
  {
    id: 'spell-713',
    image: '/sprites/spells/spell-713.png',
    cell: 64,
    cols: 23,
    rows: 9,
  },
  {
    id: 'spell-720',
    image: '/sprites/spells/spell-720.png',
    cell: 64,
    cols: 20,
    rows: 9,
  },
  {
    id: 'spell-721',
    image: '/sprites/spells/spell-721.png',
    cell: 64,
    cols: 22,
    rows: 9,
  },
  {
    id: 'spell-722',
    image: '/sprites/spells/spell-722.png',
    cell: 64,
    cols: 23,
    rows: 9,
  },
  {
    id: 'spell-723',
    image: '/sprites/spells/spell-723.png',
    cell: 64,
    cols: 23,
    rows: 9,
  },
  {
    id: 'spell-766',
    image: '/sprites/spells/spell-766.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-767',
    image: '/sprites/spells/spell-767.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-768',
    image: '/sprites/spells/spell-768.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-769',
    image: '/sprites/spells/spell-769.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-776',
    image: '/sprites/spells/spell-776.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-777',
    image: '/sprites/spells/spell-777.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-778',
    image: '/sprites/spells/spell-778.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-779',
    image: '/sprites/spells/spell-779.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-786',
    image: '/sprites/spells/spell-786.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-787',
    image: '/sprites/spells/spell-787.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-788',
    image: '/sprites/spells/spell-788.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-789',
    image: '/sprites/spells/spell-789.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-825',
    image: '/sprites/spells/spell-825.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-826',
    image: '/sprites/spells/spell-826.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-827',
    image: '/sprites/spells/spell-827.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-828',
    image: '/sprites/spells/spell-828.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-835',
    image: '/sprites/spells/spell-835.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-836',
    image: '/sprites/spells/spell-836.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-837',
    image: '/sprites/spells/spell-837.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-838',
    image: '/sprites/spells/spell-838.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-845',
    image: '/sprites/spells/spell-845.png',
    cell: 64,
    cols: 11,
    rows: 9,
  },
  {
    id: 'spell-846',
    image: '/sprites/spells/spell-846.png',
    cell: 64,
    cols: 11,
    rows: 9,
  },
  {
    id: 'spell-847',
    image: '/sprites/spells/spell-847.png',
    cell: 64,
    cols: 11,
    rows: 9,
  },
  {
    id: 'spell-848',
    image: '/sprites/spells/spell-848.png',
    cell: 64,
    cols: 11,
    rows: 9,
  },
  {
    id: 'spell-861',
    image: '/sprites/spells/spell-861.png',
    cell: 64,
    cols: 11,
    rows: 9,
  },
  {
    id: 'spell-862',
    image: '/sprites/spells/spell-862.png',
    cell: 64,
    cols: 11,
    rows: 9,
  },
  {
    id: 'spell-863',
    image: '/sprites/spells/spell-863.png',
    cell: 64,
    cols: 11,
    rows: 9,
  },
  {
    id: 'spell-864',
    image: '/sprites/spells/spell-864.png',
    cell: 64,
    cols: 11,
    rows: 9,
  },
  {
    id: 'spell-871',
    image: '/sprites/spells/spell-871.png',
    cell: 64,
    cols: 11,
    rows: 9,
  },
  {
    id: 'spell-872',
    image: '/sprites/spells/spell-872.png',
    cell: 64,
    cols: 11,
    rows: 9,
  },
  {
    id: 'spell-873',
    image: '/sprites/spells/spell-873.png',
    cell: 64,
    cols: 11,
    rows: 9,
  },
  {
    id: 'spell-874',
    image: '/sprites/spells/spell-874.png',
    cell: 64,
    cols: 11,
    rows: 9,
  },
  {
    id: 'spell-881',
    image: '/sprites/spells/spell-881.png',
    cell: 64,
    cols: 11,
    rows: 9,
  },
  {
    id: 'spell-882',
    image: '/sprites/spells/spell-882.png',
    cell: 64,
    cols: 11,
    rows: 9,
  },
  {
    id: 'spell-883',
    image: '/sprites/spells/spell-883.png',
    cell: 64,
    cols: 11,
    rows: 9,
  },
  {
    id: 'spell-884',
    image: '/sprites/spells/spell-884.png',
    cell: 64,
    cols: 11,
    rows: 9,
  },
  {
    id: 'spell-925',
    image: '/sprites/spells/spell-925.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-926',
    image: '/sprites/spells/spell-926.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-927',
    image: '/sprites/spells/spell-927.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-928',
    image: '/sprites/spells/spell-928.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-935',
    image: '/sprites/spells/spell-935.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-936',
    image: '/sprites/spells/spell-936.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-937',
    image: '/sprites/spells/spell-937.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-938',
    image: '/sprites/spells/spell-938.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-945',
    image: '/sprites/spells/spell-945.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-946',
    image: '/sprites/spells/spell-946.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-947',
    image: '/sprites/spells/spell-947.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-948',
    image: '/sprites/spells/spell-948.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-975',
    image: '/sprites/spells/spell-975.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-976',
    image: '/sprites/spells/spell-976.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-977',
    image: '/sprites/spells/spell-977.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-978',
    image: '/sprites/spells/spell-978.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-985',
    image: '/sprites/spells/spell-985.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-986',
    image: '/sprites/spells/spell-986.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-987',
    image: '/sprites/spells/spell-987.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-988',
    image: '/sprites/spells/spell-988.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-995',
    image: '/sprites/spells/spell-995.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-996',
    image: '/sprites/spells/spell-996.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-997',
    image: '/sprites/spells/spell-997.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-998',
    image: '/sprites/spells/spell-998.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-1010',
    image: '/sprites/spells/spell-1010.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-1011',
    image: '/sprites/spells/spell-1011.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-1012',
    image: '/sprites/spells/spell-1012.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-1013',
    image: '/sprites/spells/spell-1013.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-1020',
    image: '/sprites/spells/spell-1020.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-1021',
    image: '/sprites/spells/spell-1021.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-1022',
    image: '/sprites/spells/spell-1022.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-1023',
    image: '/sprites/spells/spell-1023.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-1030',
    image: '/sprites/spells/spell-1030.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-1031',
    image: '/sprites/spells/spell-1031.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-1032',
    image: '/sprites/spells/spell-1032.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-1033',
    image: '/sprites/spells/spell-1033.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-1053',
    image: '/sprites/spells/spell-1053.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-1054',
    image: '/sprites/spells/spell-1054.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-1055',
    image: '/sprites/spells/spell-1055.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-1056',
    image: '/sprites/spells/spell-1056.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-1063',
    image: '/sprites/spells/spell-1063.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-1064',
    image: '/sprites/spells/spell-1064.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-1065',
    image: '/sprites/spells/spell-1065.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-1066',
    image: '/sprites/spells/spell-1066.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-1073',
    image: '/sprites/spells/spell-1073.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-1074',
    image: '/sprites/spells/spell-1074.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-1075',
    image: '/sprites/spells/spell-1075.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-1076',
    image: '/sprites/spells/spell-1076.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-1101',
    image: '/sprites/spells/spell-1101.png',
    cell: 64,
    cols: 7,
    rows: 9,
  },
  {
    id: 'spell-1102',
    image: '/sprites/spells/spell-1102.png',
    cell: 64,
    cols: 7,
    rows: 9,
  },
  {
    id: 'spell-1103',
    image: '/sprites/spells/spell-1103.png',
    cell: 64,
    cols: 7,
    rows: 9,
  },
  {
    id: 'spell-1104',
    image: '/sprites/spells/spell-1104.png',
    cell: 64,
    cols: 7,
    rows: 9,
  },
  {
    id: 'spell-1111',
    image: '/sprites/spells/spell-1111.png',
    cell: 64,
    cols: 7,
    rows: 9,
  },
  {
    id: 'spell-1112',
    image: '/sprites/spells/spell-1112.png',
    cell: 64,
    cols: 7,
    rows: 9,
  },
  {
    id: 'spell-1113',
    image: '/sprites/spells/spell-1113.png',
    cell: 64,
    cols: 7,
    rows: 9,
  },
  {
    id: 'spell-1114',
    image: '/sprites/spells/spell-1114.png',
    cell: 64,
    cols: 7,
    rows: 9,
  },
  {
    id: 'spell-1121',
    image: '/sprites/spells/spell-1121.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-1122',
    image: '/sprites/spells/spell-1122.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-1123',
    image: '/sprites/spells/spell-1123.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-1124',
    image: '/sprites/spells/spell-1124.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-1156',
    image: '/sprites/spells/spell-1156.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-1157',
    image: '/sprites/spells/spell-1157.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-1158',
    image: '/sprites/spells/spell-1158.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-1159',
    image: '/sprites/spells/spell-1159.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-1166',
    image: '/sprites/spells/spell-1166.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-1167',
    image: '/sprites/spells/spell-1167.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-1168',
    image: '/sprites/spells/spell-1168.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-1169',
    image: '/sprites/spells/spell-1169.png',
    cell: 64,
    cols: 8,
    rows: 9,
  },
  {
    id: 'spell-1176',
    image: '/sprites/spells/spell-1176.png',
    cell: 64,
    cols: 9,
    rows: 9,
  },
  {
    id: 'spell-1177',
    image: '/sprites/spells/spell-1177.png',
    cell: 64,
    cols: 9,
    rows: 9,
  },
  {
    id: 'spell-1178',
    image: '/sprites/spells/spell-1178.png',
    cell: 64,
    cols: 9,
    rows: 9,
  },
  {
    id: 'spell-1179',
    image: '/sprites/spells/spell-1179.png',
    cell: 64,
    cols: 9,
    rows: 9,
  },
  {
    id: 'spell-1224',
    image: '/sprites/spells/spell-1224.png',
    cell: 64,
    cols: 9,
    rows: 9,
  },
  {
    id: 'spell-1225',
    image: '/sprites/spells/spell-1225.png',
    cell: 64,
    cols: 9,
    rows: 9,
  },
  {
    id: 'spell-1226',
    image: '/sprites/spells/spell-1226.png',
    cell: 64,
    cols: 9,
    rows: 9,
  },
  {
    id: 'spell-1227',
    image: '/sprites/spells/spell-1227.png',
    cell: 64,
    cols: 9,
    rows: 9,
  },
  {
    id: 'spell-1234',
    image: '/sprites/spells/spell-1234.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-1235',
    image: '/sprites/spells/spell-1235.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-1236',
    image: '/sprites/spells/spell-1236.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-1237',
    image: '/sprites/spells/spell-1237.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-1244',
    image: '/sprites/spells/spell-1244.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-1245',
    image: '/sprites/spells/spell-1245.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-1246',
    image: '/sprites/spells/spell-1246.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-1247',
    image: '/sprites/spells/spell-1247.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-1250',
    image: '/sprites/spells/spell-1250.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-1251',
    image: '/sprites/spells/spell-1251.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-1252',
    image: '/sprites/spells/spell-1252.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-1253',
    image: '/sprites/spells/spell-1253.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-1260',
    image: '/sprites/spells/spell-1260.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-1261',
    image: '/sprites/spells/spell-1261.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-1262',
    image: '/sprites/spells/spell-1262.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-1263',
    image: '/sprites/spells/spell-1263.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-1270',
    image: '/sprites/spells/spell-1270.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-1271',
    image: '/sprites/spells/spell-1271.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-1272',
    image: '/sprites/spells/spell-1272.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-1273',
    image: '/sprites/spells/spell-1273.png',
    cell: 64,
    cols: 10,
    rows: 9,
  },
  {
    id: 'spell-1326',
    image: '/sprites/spells/spell-1326.png',
    cell: 64,
    cols: 11,
    rows: 9,
  },
  {
    id: 'spell-1327',
    image: '/sprites/spells/spell-1327.png',
    cell: 64,
    cols: 11,
    rows: 9,
  },
  {
    id: 'spell-1328',
    image: '/sprites/spells/spell-1328.png',
    cell: 64,
    cols: 11,
    rows: 9,
  },
  {
    id: 'spell-1329',
    image: '/sprites/spells/spell-1329.png',
    cell: 64,
    cols: 11,
    rows: 9,
  },
  {
    id: 'spell-1336',
    image: '/sprites/spells/spell-1336.png',
    cell: 64,
    cols: 11,
    rows: 9,
  },
  {
    id: 'spell-1337',
    image: '/sprites/spells/spell-1337.png',
    cell: 64,
    cols: 11,
    rows: 9,
  },
  {
    id: 'spell-1338',
    image: '/sprites/spells/spell-1338.png',
    cell: 64,
    cols: 11,
    rows: 9,
  },
  {
    id: 'spell-1339',
    image: '/sprites/spells/spell-1339.png',
    cell: 64,
    cols: 11,
    rows: 9,
  },
  {
    id: 'spell-1346',
    image: '/sprites/spells/spell-1346.png',
    cell: 64,
    cols: 11,
    rows: 9,
  },
  {
    id: 'spell-1347',
    image: '/sprites/spells/spell-1347.png',
    cell: 64,
    cols: 11,
    rows: 9,
  },
  {
    id: 'spell-1348',
    image: '/sprites/spells/spell-1348.png',
    cell: 64,
    cols: 11,
    rows: 9,
  },
  {
    id: 'spell-1349',
    image: '/sprites/spells/spell-1349.png',
    cell: 64,
    cols: 11,
    rows: 9,
  },
  {
    id: 'spell-1350',
    image: '/sprites/spells/spell-1350.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-1351',
    image: '/sprites/spells/spell-1351.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-1352',
    image: '/sprites/spells/spell-1352.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-1353',
    image: '/sprites/spells/spell-1353.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-1360',
    image: '/sprites/spells/spell-1360.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-1361',
    image: '/sprites/spells/spell-1361.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-1362',
    image: '/sprites/spells/spell-1362.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-1363',
    image: '/sprites/spells/spell-1363.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-1370',
    image: '/sprites/spells/spell-1370.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-1371',
    image: '/sprites/spells/spell-1371.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-1372',
    image: '/sprites/spells/spell-1372.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-1373',
    image: '/sprites/spells/spell-1373.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-1405',
    image: '/sprites/spells/spell-1405.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-1406',
    image: '/sprites/spells/spell-1406.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-1407',
    image: '/sprites/spells/spell-1407.png',
    cell: 64,
    cols: 12,
    rows: 9,
  },
  {
    id: 'spell-1408',
    image: '/sprites/spells/spell-1408.png',
    cell: 64,
    cols: 13,
    rows: 9,
  },
  {
    id: 'spell-1415',
    image: '/sprites/spells/spell-1415.png',
    cell: 64,
    cols: 13,
    rows: 9,
  },
  {
    id: 'spell-1416',
    image: '/sprites/spells/spell-1416.png',
    cell: 64,
    cols: 13,
    rows: 9,
  },
  {
    id: 'spell-1417',
    image: '/sprites/spells/spell-1417.png',
    cell: 64,
    cols: 13,
    rows: 9,
  },
  {
    id: 'spell-1418',
    image: '/sprites/spells/spell-1418.png',
    cell: 64,
    cols: 13,
    rows: 9,
  },
  {
    id: 'spell-1425',
    image: '/sprites/spells/spell-1425.png',
    cell: 64,
    cols: 13,
    rows: 9,
  },
  {
    id: 'spell-1426',
    image: '/sprites/spells/spell-1426.png',
    cell: 64,
    cols: 13,
    rows: 9,
  },
  {
    id: 'spell-1427',
    image: '/sprites/spells/spell-1427.png',
    cell: 64,
    cols: 13,
    rows: 9,
  },
  {
    id: 'spell-1428',
    image: '/sprites/spells/spell-1428.png',
    cell: 64,
    cols: 13,
    rows: 9,
  },
  {
    id: 'spell-1471',
    image: '/sprites/spells/spell-1471.png',
    cell: 64,
    cols: 13,
    rows: 9,
  },
  {
    id: 'spell-1472',
    image: '/sprites/spells/spell-1472.png',
    cell: 64,
    cols: 13,
    rows: 9,
  },
  {
    id: 'spell-1473',
    image: '/sprites/spells/spell-1473.png',
    cell: 64,
    cols: 13,
    rows: 9,
  },
  {
    id: 'spell-1474',
    image: '/sprites/spells/spell-1474.png',
    cell: 64,
    cols: 13,
    rows: 9,
  },
  {
    id: 'spell-1481',
    image: '/sprites/spells/spell-1481.png',
    cell: 64,
    cols: 13,
    rows: 9,
  },
  {
    id: 'spell-1482',
    image: '/sprites/spells/spell-1482.png',
    cell: 64,
    cols: 13,
    rows: 9,
  },
  {
    id: 'spell-1483',
    image: '/sprites/spells/spell-1483.png',
    cell: 64,
    cols: 13,
    rows: 9,
  },
  {
    id: 'spell-1484',
    image: '/sprites/spells/spell-1484.png',
    cell: 64,
    cols: 13,
    rows: 9,
  },
  {
    id: 'spell-1491',
    image: '/sprites/spells/spell-1491.png',
    cell: 64,
    cols: 13,
    rows: 9,
  },
  {
    id: 'spell-1492',
    image: '/sprites/spells/spell-1492.png',
    cell: 64,
    cols: 13,
    rows: 9,
  },
  {
    id: 'spell-1493',
    image: '/sprites/spells/spell-1493.png',
    cell: 64,
    cols: 13,
    rows: 9,
  },
  {
    id: 'spell-1494',
    image: '/sprites/spells/spell-1494.png',
    cell: 64,
    cols: 13,
    rows: 9,
  },
  {
    id: 'spell-1506',
    image: '/sprites/spells/spell-1506.png',
    cell: 64,
    cols: 13,
    rows: 9,
  },
  {
    id: 'spell-1507',
    image: '/sprites/spells/spell-1507.png',
    cell: 64,
    cols: 13,
    rows: 9,
  },
  {
    id: 'spell-1508',
    image: '/sprites/spells/spell-1508.png',
    cell: 64,
    cols: 13,
    rows: 9,
  },
  {
    id: 'spell-1509',
    image: '/sprites/spells/spell-1509.png',
    cell: 64,
    cols: 13,
    rows: 9,
  },
  {
    id: 'spell-1516',
    image: '/sprites/spells/spell-1516.png',
    cell: 64,
    cols: 13,
    rows: 9,
  },
  {
    id: 'spell-1517',
    image: '/sprites/spells/spell-1517.png',
    cell: 64,
    cols: 13,
    rows: 9,
  },
  {
    id: 'spell-1518',
    image: '/sprites/spells/spell-1518.png',
    cell: 64,
    cols: 13,
    rows: 9,
  },
  {
    id: 'spell-1519',
    image: '/sprites/spells/spell-1519.png',
    cell: 64,
    cols: 13,
    rows: 9,
  },
  {
    id: 'spell-1526',
    image: '/sprites/spells/spell-1526.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-1527',
    image: '/sprites/spells/spell-1527.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-1528',
    image: '/sprites/spells/spell-1528.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-1529',
    image: '/sprites/spells/spell-1529.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-1572',
    image: '/sprites/spells/spell-1572.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-1573',
    image: '/sprites/spells/spell-1573.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-1574',
    image: '/sprites/spells/spell-1574.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-1575',
    image: '/sprites/spells/spell-1575.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-1582',
    image: '/sprites/spells/spell-1582.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-1583',
    image: '/sprites/spells/spell-1583.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-1584',
    image: '/sprites/spells/spell-1584.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-1585',
    image: '/sprites/spells/spell-1585.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-1592',
    image: '/sprites/spells/spell-1592.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-1593',
    image: '/sprites/spells/spell-1593.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-1594',
    image: '/sprites/spells/spell-1594.png',
    cell: 64,
    cols: 15,
    rows: 9,
  },
  {
    id: 'spell-1595',
    image: '/sprites/spells/spell-1595.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-1615',
    image: '/sprites/spells/spell-1615.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-1616',
    image: '/sprites/spells/spell-1616.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-1617',
    image: '/sprites/spells/spell-1617.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-1618',
    image: '/sprites/spells/spell-1618.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-1625',
    image: '/sprites/spells/spell-1625.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-1626',
    image: '/sprites/spells/spell-1626.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-1627',
    image: '/sprites/spells/spell-1627.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-1628',
    image: '/sprites/spells/spell-1628.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-1635',
    image: '/sprites/spells/spell-1635.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-1636',
    image: '/sprites/spells/spell-1636.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-1637',
    image: '/sprites/spells/spell-1637.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-1638',
    image: '/sprites/spells/spell-1638.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-1655',
    image: '/sprites/spells/spell-1655.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-1656',
    image: '/sprites/spells/spell-1656.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-1657',
    image: '/sprites/spells/spell-1657.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-1658',
    image: '/sprites/spells/spell-1658.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-1665',
    image: '/sprites/spells/spell-1665.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-1666',
    image: '/sprites/spells/spell-1666.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-1667',
    image: '/sprites/spells/spell-1667.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-1668',
    image: '/sprites/spells/spell-1668.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-1675',
    image: '/sprites/spells/spell-1675.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-1676',
    image: '/sprites/spells/spell-1676.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-1677',
    image: '/sprites/spells/spell-1677.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-1678',
    image: '/sprites/spells/spell-1678.png',
    cell: 64,
    cols: 14,
    rows: 9,
  },
  {
    id: 'spell-1712',
    image: '/sprites/spells/spell-1712.png',
    cell: 64,
    cols: 15,
    rows: 9,
  },
  {
    id: 'spell-1713',
    image: '/sprites/spells/spell-1713.png',
    cell: 64,
    cols: 15,
    rows: 9,
  },
  {
    id: 'spell-1714',
    image: '/sprites/spells/spell-1714.png',
    cell: 64,
    cols: 15,
    rows: 9,
  },
  {
    id: 'spell-1715',
    image: '/sprites/spells/spell-1715.png',
    cell: 64,
    cols: 15,
    rows: 9,
  },
  {
    id: 'spell-1722',
    image: '/sprites/spells/spell-1722.png',
    cell: 64,
    cols: 15,
    rows: 9,
  },
  {
    id: 'spell-1723',
    image: '/sprites/spells/spell-1723.png',
    cell: 64,
    cols: 15,
    rows: 9,
  },
  {
    id: 'spell-1724',
    image: '/sprites/spells/spell-1724.png',
    cell: 64,
    cols: 15,
    rows: 9,
  },
  {
    id: 'spell-1725',
    image: '/sprites/spells/spell-1725.png',
    cell: 64,
    cols: 15,
    rows: 9,
  },
  {
    id: 'spell-1732',
    image: '/sprites/spells/spell-1732.png',
    cell: 64,
    cols: 15,
    rows: 9,
  },
  {
    id: 'spell-1733',
    image: '/sprites/spells/spell-1733.png',
    cell: 64,
    cols: 15,
    rows: 9,
  },
  {
    id: 'spell-1734',
    image: '/sprites/spells/spell-1734.png',
    cell: 64,
    cols: 15,
    rows: 9,
  },
  {
    id: 'spell-1735',
    image: '/sprites/spells/spell-1735.png',
    cell: 64,
    cols: 15,
    rows: 9,
  },
  {
    id: 'spell-1761',
    image: '/sprites/spells/spell-1761.png',
    cell: 64,
    cols: 16,
    rows: 9,
  },
  {
    id: 'spell-1762',
    image: '/sprites/spells/spell-1762.png',
    cell: 64,
    cols: 16,
    rows: 9,
  },
  {
    id: 'spell-1763',
    image: '/sprites/spells/spell-1763.png',
    cell: 64,
    cols: 16,
    rows: 9,
  },
  {
    id: 'spell-1764',
    image: '/sprites/spells/spell-1764.png',
    cell: 64,
    cols: 17,
    rows: 9,
  },
  {
    id: 'spell-1771',
    image: '/sprites/spells/spell-1771.png',
    cell: 64,
    cols: 17,
    rows: 9,
  },
  {
    id: 'spell-1772',
    image: '/sprites/spells/spell-1772.png',
    cell: 64,
    cols: 17,
    rows: 9,
  },
  {
    id: 'spell-1773',
    image: '/sprites/spells/spell-1773.png',
    cell: 64,
    cols: 17,
    rows: 9,
  },
  {
    id: 'spell-1774',
    image: '/sprites/spells/spell-1774.png',
    cell: 64,
    cols: 17,
    rows: 9,
  },
  {
    id: 'spell-1781',
    image: '/sprites/spells/spell-1781.png',
    cell: 64,
    cols: 18,
    rows: 9,
  },
  {
    id: 'spell-1782',
    image: '/sprites/spells/spell-1782.png',
    cell: 64,
    cols: 18,
    rows: 9,
  },
  {
    id: 'spell-1783',
    image: '/sprites/spells/spell-1783.png',
    cell: 64,
    cols: 15,
    rows: 9,
  },
  {
    id: 'spell-1784',
    image: '/sprites/spells/spell-1784.png',
    cell: 64,
    cols: 18,
    rows: 9,
  },
];
